import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

export const typesListInitialState = {
    assetCategories: getInitialState.list(),
    assetTypes: getInitialState.list(),
    assetStatus: getInitialState.list(),
    auditAssignmentStatus: getInitialState.list(),
    auditStatus: getInitialState.list(),
    exclusionImageTypes: getInitialState.list(),
    exclusionReasonTypes: getInitialState.list(),
    fileGroups: getInitialState.list(),
    fileMappings: getInitialState.list(),
    fileTypes: getInitialState.list(),
    groupAuditStatus: getInitialState.list(),
    identifiers: getInitialState.list(),
    imageTypeIdentifiers: getInitialState.list(),
    imageTypes: getInitialState.list(),
    makes: getInitialState.list(),
    makeTypes: getInitialState.list(),
    organisationTypes: getInitialState.list(),
    typeAttributes: getInitialState.list(),
    typeIdentifiers: getInitialState.list(),
    uploadStatus: getInitialState.list(),
    validationFields: getInitialState.list(),
    validationRules: getInitialState.list(),
};

export default function (state = typesListInitialState, action) {
    switch (action.type) {
        case actionTypes.TYPES_LIST_CLEAR: {
            return typesListInitialState;
        }
        case actionTypes.TYPES_LIST_GET_SUCCESS: {
            return state;
        }
        case actionTypes.TYPES_LIST_SELECT_SUCCESS: {
            const { typesList } = action.payload;
            return typesList;
        }
        default: {
            return state;
        }
    }
}
